import axios from "axios"
import constants from "../constants"
import { AppUser, TeamRoles } from "../views/practice/team-members/types"
import { Groups, TeamMember } from "../types"
import { User } from "../redux/user"

const createUser = async (user: AppUser, customerNumber: string) => {
  const response = await axios.post(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users`, user)

  return response.data
}

const updateUser = async (user: AppUser | Partial<User>, customerNumber: string) => {
  const response = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/users`, user)

  return response.data
}

const updateUserGroups = async (customerNumber: string, userId: string, groups: Partial<Groups>[], accessLevel: TeamRoles) => {
  const data = {
    user_id: userId,
    groups: groups.map(({ group_id }) => ({ group_id })),
    access_level: accessLevel,
  }
  const response = await axios.put(`${constants.ONTRAQ_API_URL}/api2/${customerNumber}/user-groups`, data)

  return response.data
}

const sendValidationEmail = async (teamMember: TeamMember) => {
  await axios.post(`${constants.ONTRAQ_API_URL}/api2/${teamMember.customer_number}/users/resend-validation-email`, teamMember)
}

export {
  createUser,
  updateUser,
  updateUserGroups,
  sendValidationEmail,
}
